import React, { Component } from "react";
import { Table, Input, InputNumber, Button, Switch, Divider, message, Icon } from 'antd';
import { createUuid } from "../../../../utils/NHCore";
import PropTypes from 'prop-types';
import style from '../index.css';
import NHInputPicker from "../../../common/NHInputPicker";
import NHInputRender from "../../../common/NHInputPicker/render";

/**
 * 步骤二配置环节信息
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-08 11:18:31
 * Version: 1.0
 * Modify log:
 */
class SeconedStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            hjywxData: [] //配置的环节业务项信息数据
        }
        this.cacheData = this.state.hjywxData.map(item => ({ ...item })); //缓存编辑环节业务项信息数据
    }

    componentDidMount() {
        if (this.props.data) {
            this.setState({ hjywxData: this.props.data });
        }
    }

    //编辑环节信息
    edit = (pkid) => {
        const newData = [...this.state.hjywxData];
        const target = newData.filter(item => pkid === item.pkid)[0];
        if (target) {
            target.editable = true;
            this.setState({ hjywxData: newData });
        }
    }

    //删除环节信息
    delete = (record, pkid) => {
        //删除操作将后续排序号-1
        const newData = this.state.hjywxData.map(item => {
            if (item && (item.pxh > record.pxh)) {
                item.pxh = item.pxh - 1;
            }
            return item;
        });

        const target = newData.filter(item => pkid !== item.pkid);
        if (target) {
            this.props.onChange(target);
            this.setState({ hjywxData: target });
            this.cacheData = target.filter(item => item.zdmc != '' && item.kjcs != '')
                .map(item => ({ ...item }));
        }
    }

    //保存编辑的环节信息
    save = (pkid) => {
        const newData = [...this.state.hjywxData];
        const target = newData.filter(item => pkid === item.pkid)[0];
        if (target) {
            if (target.zdmc != '' && target.kjcs != '') {
                delete target.editable;
                this.props.onChange(newData);
                this.setState({ hjywxData: newData });
                this.cacheData = newData.filter(item => item.zdmc != '' && item.kjcs != '')
                    .map(item => ({ ...item }));
            } else {
                message.error('请填写字段名称和选择输入框类型！');
            }
        }
    }

    //取消编辑环节信息
    cancel = (record, pkid) => {
        const newData = [...this.state.hjywxData];
        const target = newData.filter(item => pkid === item.pkid)[0];
        if (target) {

            let cache = this.cacheData.filter(item => {
                if (item) {
                    return pkid === item.pkid
                }
            })[0];

            if (cache) {

                //如果是点击取消时，如果缓存数据里有，则获取缓存数据
                Object.assign(target, cache);
                delete target.editable;
                this.setState({ hjywxData: newData });

            } else {

                //如果是点击取消时，缓存数据里没有找到，则删除这条数据
                const afterDelTarget = newData.map(item => {
                    if (item && (item.pxh > record.pxh)) {
                        item.pxh = item.pxh - 1;
                    }
                    return item;
                }).filter(item => pkid !== item.pkid);

                if (afterDelTarget) {
                    this.props.onChange(afterDelTarget);
                    this.setState({ hjywxData: afterDelTarget });
                }

            }
        }
    }

    //表格单元格编辑时回调
    handleEditableCellChange = (value, pkid, column) => {
        const newData = [...this.state.hjywxData];
        const target = newData.filter(item => pkid === item.pkid)[0];

        if (target) {
            target[column] = value;
            this.setState({ hjywxData: newData });
        }
    }

    //添加业务项回调
    handleAddBtnClick = () => {

        const hjywxData = [...this.state.hjywxData];
        let hjywxLength = hjywxData.length;
        if (hjywxLength) {
            if (hjywxLength > 0 && (hjywxData[hjywxLength - 1].zdmc == '' || hjywxData[hjywxLength - 1].kjcs == '')) {
                message.error('请填写字段名称和选择输入框类型！');
                return;
            } else {
                this.save(hjywxData[hjywxLength - 1].pkid);
            }
        }

        let newHjywxData = {
            pkid: createUuid(), //主键
            nd: '', //年度
            hjid: '', //环节ID
            ywxid: '', //业务项ID
            pxh: hjywxData.length + 1, //排序号
            sfbt: '0', //是否必填
            mrz: '', //默认值
            zt: '1', //是否启用
            zdmc: '', //字段名称
            kjcs: '', //控件参数
            editable: true, //编辑模式
        };
        hjywxData.push(newHjywxData);
        this.props.onChange(hjywxData);
        this.setState({ hjywxData: hjywxData });

    }

    render() {

        const columns = [
            {
                title: '排序号',
                key: 'pxh',
                dataIndex: 'pxh',
                width: '60px'
            }, {
                title: '字段名称',
                key: 'zdmc',
                dataIndex: 'zdmc',
                width: '100px',
                render: (text, record) => {
                    const editable = record.editable;
                    return (
                        editable ?
                            <Input style={{ margin: '-5px 0', width: '100%' }} value={text}
                                onChange={(e) => {
                                    this.handleEditableCellChange(e.target.value, record.pkid, 'zdmc')
                                }} />
                            : text
                    );
                },
            }, {
                title: '输入框类型',
                key: 'kjcs',
                dataIndex: 'kjcs',
                width: '120px',
                render: (text, record) => {
                    const editable = record.editable;
                    return (
                        editable ?
                            <NHInputPicker value={record.kjcs}
                                onChange={value => this.handleEditableCellChange(value, record.pkid, 'kjcs')} />
                            : <NHInputRender feature={record.kjcs} />
                    );
                },
            }, {
                title: '默认值',
                key: 'mrz',
                dataIndex: 'mrz',
                width: '80px',
                render: (text, record) => {
                    const editable = record.editable;
                    return (
                        editable ?
                            <Input style={{ margin: '-5px 0', width: '100%' }} value={text}
                                onChange={(e) => {
                                    this.handleEditableCellChange(e.target.value, record.pkid, 'mrz')
                                }} />
                            : text
                    );
                },
            }, {
                title: '是否必填',
                key: 'sfbt',
                dataIndex: 'sfbt',
                width: '60px',
                render: (text, record) => {
                    const editable = record.editable;
                    return (
                        editable ?
                            <Switch style={{ margin: '-5px 0' }} checkedChildren="是" unCheckedChildren="否"
                                checked={text == '1' ? true : false}
                                onChange={value => this.handleEditableCellChange(value ? '1' : '0', record.pkid, 'sfbt')} />
                            : (text == '1' ? <Icon type="check-circle" style={{ fontSize: 16, color: '#53c41a' }} />
                                : <Icon type="close-circle" style={{ fontSize: 16, color: '#ff4d4f' }} />)
                    );
                },
            }, {
                title: '是否启用',
                key: 'zt',
                dataIndex: 'zt',
                width: '60px',
                render: (text, record) => {
                    const editable = record.editable;
                    return (
                        editable ?
                            <Switch style={{ margin: '-5px 0' }} checkedChildren="启用" unCheckedChildren="停用"
                                checked={text == '1' ? true : false}
                                onChange={value => this.handleEditableCellChange(value ? '1' : '0', record.pkid, 'zt')} />
                            : (text == '1' ? <Icon type="check-circle" style={{ fontSize: 16, color: '#53c41a' }} />
                                : <Icon type="close-circle" style={{ fontSize: 16, color: '#ff4d4f' }} />)
                    );
                },
            }, {
                title: '操作',
                key: 'operation',
                dataIndex: 'operation',
                width: '110px',
                render: (text, record) => {
                    const { editable } = record;
                    return (
                        <div className={style["editable-row-operations"]}>
                            {
                                editable ?
                                    <span>
                                        <a style={{ margin: 0 }} onClick={() => this.save(record.pkid)}>保存</a>
                                        <Divider type={'vertical'} />
                                        <a onClick={() => this.cancel(record, record.pkid)}>取消</a>
                                    </span>
                                    : <span>
                                        <a style={{ margin: 0 }} onClick={() => this.edit(record.pkid)}>编辑</a>
                                        <Divider type={'vertical'} />
                                        <a onClick={() => this.delete(record, record.pkid)}>删除</a>
                                    </span>
                            }
                        </div>
                    );
                },
            }
        ];

        const {hjlx} = this.props.hjxxData;

        return (
            <div>
                <Table dataSource={this.state.hjywxData} columns={columns} pagination={false} />
                {hjlx==='1' &&
                <p style={{color: '#ff4d4f',textAlign:'center'}}>固定环节不支持业务项配置</p>
                }
                {hjlx!=='1' &&
                <Button style={{ marginTop: '5px', width: '100%' }} type="dashed" icon={'plus'} onClick={this.handleAddBtnClick}>
                    添加业务项
                </Button>}
            </div>
        )
    }
}

SeconedStep.propTypes = {
    data: PropTypes.array, //缓存数据
    onChange: PropTypes.func //环节配置信息改变时回调
}

export default SeconedStep;


// WEBPACK FOOTER //
// ./components/lcgl/hjgl/edit-form/step-second.js